
import { createStore, applyMiddleware, combineReducers, compose } from 'redux'
import { createEpicMiddleware } from 'redux-observable'

import AppModel from './App/model'

// const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

const epicMiddleware = createEpicMiddleware();
const store = createStore(
    combineReducers({
        app: AppModel.reducer,
    }),
    // composeEnhancers(
    applyMiddleware(epicMiddleware)
    // )
);

epicMiddleware.run(AppModel.epic);

export default store